import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=58c54d41"
import script from "./purchase.vue?vue&type=script&lang=ts"
export * from "./purchase.vue?vue&type=script&lang=ts"
import style0 from "./purchase.vue?vue&type=style&index=0&id=58c54d41&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports